import React from 'react';
import { ErrorBoundary as EBSentry } from '@bloomays-lib/common.monitoring/browser';

import { FallbackError } from '@bloomays-lib/ui.shared';
import { Auth0User } from '@bloomays-lib/types.shared';
import { useAuthStore } from '../../stores';

const ErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const auth = useAuthStore((state) => state.auth);
  let user: Auth0User | null | undefined;
  if (auth) {
    user = auth.user;
  }

  return (
    <EBSentry
      fallback={({ error }: { error: unknown; componentStack: string; eventId: string; resetError: () => void }) =>
        React.createElement(FallbackError, { errorText: (error as Error)?.message })
      }
      beforeCapture={(scope) => {
        scope.setUser({
          id: user?.email,
          email: user?.email,
          username: user?.displayName,
        });
      }}
    >
      {children}
    </EBSentry>
  ) as React.ReactNode;
};

export { ErrorBoundary };
export default ErrorBoundary;
